import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './TechnicalAssessmentComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';


function TechnicalAssessmentComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('TechnicalAssessmentComponent');
var technicalAssessmentVM = _.get(submissionVM,pathUpdated)



// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        }
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={technicalAssessmentVM}
               // onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

TechnicalAssessmentComponent.propTypes = wizardProps;
export default withRouter(TechnicalAssessmentComponent);
